import type { ReactNode } from 'react';
import { Box } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const FormActions = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery('(max-width: 48em)', undefined, {
    getInitialValueInEffect: false
  });

  return (
    <Box
      style={
        isMobile
          ? { display: 'grid', gridAutoFlow: 'column', gridAutoColumns: '1fr', gap: 12 }
          : { display: 'flex', justifyContent: 'flex-end', gap: 12 }
      }
    >
      {children}
    </Box>
  );
};
